<template>
  <div class="page-container">
    <!--工具栏-->
    <el-scrollbar>
      <el-form
        :inline="true"
        :model="filters"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
      >
        <el-form-item label="姓名">
          <el-input
            v-model.trim="filters.userName"
            clearable
            placeholder="请输入姓名"
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input
            v-model.trim="filters.mobileNo"
            clearable
            placeholder="请输入电话号码"
            @keyup.enter.native.prevent="enterSearchMember"
          ></el-input>
        </el-form-item>
        <el-form-item label="性别">
          <el-select v-model="filters.sex" clearable placeholder="请选择性别">
            <el-option
              v-for="item in sexOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="el-icon-search"
            label="查询"
            type="primary"
            @click="findPage(1)"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="el-icon-plus"
            label="新增"
            type="warning"
            @click="handleAdd"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="el-icon-refresh"
            label="刷新"
            type="primary"
            @click="handleRefresh"
          />
        </el-form-item>
      </el-form>
    </el-scrollbar>
    <!--表格内容栏-->
    <kt-table
      ref="ktTable"
      v-loading="loading"
      :height="'460'"
      element-loading-text="拼命加载中"
      :data="pageResult"
      :columns="filterColumns"
      :operationWidth="320"
      :showEdit="true"
      :showDelete="true"
      :showLook="true"
      :showResetCode="true"
      @findPage="findPage"
      @handleEdit="handleEdit"
      @handleDelete="handleDelete"
      @handleLook="handleLook"
      @handleResetCode="handleResetCode"
      @refreshPageRequest="refreshPageRequest"
    >
    </kt-table>
    <!-- 新增志愿者和修改志愿者的dialog模态框-->
    <el-dialog
      class="volunteerdialog"
      :title="operation ? '新增志愿者' : '编辑志愿者'"
      width="70%"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      @close="closeDialogReset"
    >
      <el-form
        :model="dataForm"
        label-width="100px"
        :rules="dataFormRules"
        ref="dataForm"
        :size="size"
        label-position="right"
      >
        <el-row>
          <el-col :span="18">
            <el-row>
              <el-col :span="11" :offset="1">
                <el-form-item label="姓名:" prop="userName">
                  <el-input
                    v-model.trim="dataForm.userName"
                    auto-complete="off"
                    placeholder="请输入姓名"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="11" :offset="1">
                <el-form-item label="身份证号:" prop="idCard">
                  <el-input
                    v-model="dataForm.idCard"
                    auto-complete="off"
                    placeholder="请输入身份证号"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="11" :offset="1">
                <el-form-item label="民族:" prop="nation">
                  <el-select
                    v-model="dataForm.nation"
                    placeholder="请选择民族"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in nationOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="11" :offset="1">
                <el-form-item label="联系电话:" prop="mobileNo">
                  <!-- <input type="text" class="el-input__inner" v-model.trim="dataForm.mobileNo"  placeholder="请输入联系电话" @input="changeMobileNo"/> -->
                  <el-input
                    v-model="dataForm.mobileNo"
                    auto-complete="off"
                    placeholder="请输入联系电话"
                    @change="changeMobileNo"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="11" :offset="1">
                <el-form-item label="文化程度:" prop="education">
                  <el-select
                    v-model="dataForm.education"
                    placeholder="请选择文化程度"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in educationoptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="11" :offset="1">
                <el-form-item label="登录账号:" prop="loginName">
                  <el-input
                    v-model="dataForm.loginName"
                    auto-complete="off"
                    :disabled="true"
                    placeholder="请输入登录账号"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="5" :offset="1">
            <el-form-item
              label=""
              prop="headerPic"
              ref="headerPic"
              label-width="0"
            >
              <el-input v-if="false" v-model="dataForm.headerPic"></el-input>
              <div class="rz-picter">
                <!-- <span style="color: red">*</span> -->
                <img :src="avatar" alt="" class="img-avatar" />
                <input
                  type="file"
                  name="avatar"
                  id="uppic"
                  accept="image/gif,image/bmp,image/jpeg,image/jpg,image/png"
                  @change="changeImage($event)"
                  ref="avatarInput"
                  class="uppic"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :offset="1">
            <el-form-item label="职业类型:" prop="jobType">
              <el-select
                v-model="dataForm.jobType"
                placeholder="请选择职业类型"
                style="width: 100%"
              >
                <el-option
                  v-for="item in professionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <!-- 修改需求,先注释掉 -->
              <!-- <el-input v-model="dataForm.jobType" auto-complete="off" placeholder="请输入职业类型"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item label="所属区域:" prop="ownArea">
              <el-input
                v-model="dataForm.ownArea"
                auto-complete="off"
                placeholder="请输入所属区域"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item label="服务区域:" prop="serviceArea">
              <el-input
                v-model="dataForm.serviceArea"
                auto-complete="off"
                placeholder="请输入服务区域"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :offset="1">
            <el-form-item label="联系地址:" prop="address">
              <el-input
                v-model="dataForm.address"
                auto-complete="off"
                placeholder="请输入联系地址"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item label="服务技能:" prop="skill">
              <el-input
                v-model="dataForm.skill"
                auto-complete="off"
                placeholder="请输入服务技能"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item
              label="服务时间:"
              prop="serviceTimes"
              style="width: 100%"
            >
              <el-date-picker
                style="width: 100%"
                class="datepicker"
                v-model="dataForm.serviceTimes"
                type="datetime"
                placeholder="请选择服务时间"
                :picker-options="pickerServiceTime"
                @change="changeServiceTime"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7" :offset="1">
            <el-form-item label="紧急联系人:" prop="egContact">
              <el-input
                v-model="dataForm.egContact"
                auto-complete="off"
                placeholder="请输入紧急联系人"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item label="紧急联系电话:" prop="egPhone">
              <el-input
                v-model="dataForm.egPhone"
                auto-complete="off"
                placeholder="请输入紧急联系电话"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7" :offset="1">
            <el-form-item label="个人说明:" prop="remark">
              <el-input
                v-model="dataForm.remark"
                type="textarea"
                :rows="2"
                auto-complete="off"
                placeholder="请输入个人说明"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          :size="size"
          type="primary"
          :disabled="submitDisabled"
          @click.native="submitForm"
          :loading="editLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 重置密码的dialog模态框-->
    <el-dialog
      title="重置密码"
      width="30%"
      :visible.sync="dialogVisibleCode"
      :close-on-click-modal="false"
      @close="closeDialogResetCode"
    >
      <el-form
        :model="codeDataForm"
        label-width="100px"
        :rules="codeDataFormRules"
        ref="codeDataForm"
        :size="size"
        label-position="right"
      >
        <el-form-item label="密码:" prop="password">
          <el-input
            v-model="codeDataForm.password"
            auto-complete="off"
            placeholder="请输入密码"
            style="width: 80%"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码:" prop="confirmPwd">
          <el-input
            v-model="codeDataForm.confirmPwd"
            auto-complete="off"
            placeholder="请输入确认密码"
            style="width: 80%"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button :size="size" @click.native="dialogVisibleCode = false"
          >取消</el-button
        >
        <el-button
          :size="size"
          type="primary"
          @click.native="submitFormCode"
          :loading="codeLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import KtTable from "@/components/KtTable";
import KtButton from "@/components/KtButton";
import util from "@/utils/util.js";
export default {
  components: {
    KtTable,
    KtButton,
  },
  data() {
    var validateOldId = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("志愿者身份证号不能为空"));
      } else {
        //by guo 2019-3-28    添加15 和18位的身份证验证年月日合法
        var re = new RegExp(/^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/);
        //also re = /^(\d{6})(\d{4})(\d{2})(\d{2})(\d{3})([0-9]|X)$/;
        var arrSplit = value.match(re); //检查生日日期是否正确  18位
        var re2 = new RegExp(/^(\d{6})(\d{2})(\d{2})(\d{2})(\d{3})$/);
        var arrSplit2 = value.match(re2); //检查生日日期是否正确  15位
        if (arrSplit != null) {
          var check18 = util.formatDate.YearMonthDayValidate(
            arrSplit[2],
            arrSplit[3],
            arrSplit[4]
          );
          console.log(check18);
        }
        if (arrSplit2 != null) {
          if (parseInt(arrSplit2[2].substr(1)) > 0) {
            arrSplit2[2] = "19" + arrSplit2[2];
          } else {
            arrSplit2[2] = "20" + arrSplit2[2];
          }
          var check15 = util.formatDate.YearMonthDayValidate(
            arrSplit2[2],
            arrSplit2[3],
            arrSplit2[4]
          );
          console.log(check15);
        }

        //  老身份证15位  新身份证18位(最后一位可以使x)
        var reg = /^(\d{15}|\d{17}[xX\d])$/;
        if (!reg.test(value)) {
          callback(new Error("请输入正确的身份证号码"));
        } else if (check18 == false || check15 == false) {
          //by guo 2019-3-28 添加
          callback(new Error("出生日期不准确"));
        } else {
          callback();
        }
      }
    };
    var validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入手机号"));
      } else {
        //  因为现在新增了166、198、199号段的手机号
        var reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
        if (!reg.test(value)) {
          callback(new Error("手机号码格式错误"));
        } else {
          callback();
        }
      }
    };
    var validateEgPhone = (rule, value, callback) => {
      if (value != "") {
        var reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("手机号码格式错误"));
        }
      } else {
        callback();
      }
    };
    var validatePic = (rule, value, callback) => {
      if (this.filePic || this.avatar != require("@/assets/beadhouse/jia.png")) {
        callback();
      } else {
        callback(new Error("请上传图片"));
      }
    };
    return {
      filePic: "", //图片文件
      id: "", //重置密码需要的id
      loading: true,
      picture: "picture", //上传的文件格式
      bucketName: "cmny-oss", //七牛云bucket
      avatar: require("@/assets/common/jia.png"),
      sexOptions: [], //性别
      nationOptions: [], //民族
      educationoptions: [], //教育
      professionOptions: [], //职业类型
      size: "medium", //按钮的尺寸
      filters: {
        //工具栏的form表单的属性值
        userName: "",
        mobileNo: "",
        sex: "",
      },
      columns: [], //table列的集合
      filterColumns: [],
      pageRequest: { pageNum: 1, pageSize: 10 }, //默认分页
      pageResult: {},
      dataForm: {
        userName: "",
        nation: "",
        idCard: "",
        mobileNo: "",
        education: "",
        loginName: "",
        headerPic: "",
        jobType: "",
        address: "",
        skill: "",
        serviceTimes: "",
        ownArea: "",
        serviceArea: "",
        egContact: "",
        egPhone: "",
        remark: "",
      }, //新增和修改
      operation: false, // true:新增, false:编辑
      dialogVisible: false, // 新增编辑界面是否显示
      editLoading: false, //修改loading
      dataFormRules: {
        userName: [
          { required: true, message: "不能为空", trigger: "blur" }, //是否必填 //规则  //何事件触发
          //可以设置双重验证标准
          { min: 2, max: 10, message: "长度在 2到 10 的中文字符" },
          { pattern: /^[\u4e00-\u9fa5]+$/, message: "请输入由中文组成的字符" },
        ],
        idCard: [{ required: true, validator: validateOldId, trigger: "blur" }],
        // nation: [{ required: true, message: "不能为空", trigger: "change" }],
        mobileNo: [
          { required: true, validator: validatePhone, trigger: "blur" },
        ],
        // education: [{ required: true, message: "不能为空", trigger: "change" }],
        // headerPic: [{ required: true, message: "不能为空", trigger: "change" }],
        jobType: [
          // { required: true, message: "不能为空", trigger: "change" },
          /*修改需求,先注释*/
          // {required: true, message: '不能为空', trigger: 'blur'},
          // { min: 1, max:20,  message: '长度在 1到 20 个字符', }
        ],
        loginName: [
          { required: true, message: "不能为空", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "请输入由数字或者字母组成的字符",
          },
          { min: 5, max: 12, message: "长度在 5到 12 个字符" },
        ],
        ownArea: [{ min: 0, max: 20, message: "长度在 0到 20 个字符" }],
        serviceArea: [{ min: 0, max: 20, message: "长度在 0到 20 个字符" }],
        address: [{ min: 0, max: 30, message: "长度在 0到 30 个字符" }],
        skill: [{ min: 0, max: 30, message: "长度在 0到 30 个字符" }],
        serviceTimes: [{ required: false, trigger: "change" }],
        egContact: [{ min: 0, max: 20, message: "长度在 0到 20 个字符" }],
        egPhone: [
          { required: false, validator: validateEgPhone, trigger: "blur" },
        ],
        remark: [{ min: 0, max: 50, message: "长度在 0到 50 个字符" }],
      },
      codeDataForm: {
        password: "",
        confirmPwd: "",
      }, //重置密的form表单数据

      dialogVisibleCode: false, //重置密码的dialog显示和隐藏
      codeLoading: false, //重置密码的loading
      codeDataFormRules: {
        password: [
          { required: true, message: "不能为空", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "请输入由数字或者字母组成的字符",
          },
          { min: 6, max: 16, message: "长度在 6到 16 个字符" },
        ],
        confirmPwd: [
          { required: true, message: "不能为空", trigger: "blur" },
          {
            pattern: /^[A-Za-z0-9]+$/,
            message: "请输入由数字或者字母组成的字符",
          },
          { min: 6, max: 16, message: "长度在 6到 16 个字符" },
        ],
      },
      pickerBirthday: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      pickerServiceTime: {
        disabledDate(time) {
          let nowData = new Date();
          nowData = new Date(nowData.setDate(nowData.getDate() - 1));
          return time < nowData;
        },
      },
      submitDisabled: true,
    };
  },
  methods: {
    //清除校验
    clearValidate(formName) {
      //formName为传入要清除的prop ，可以是整个form表单，也可以是一个
      this.$refs[formName].clearValidate();
    },
    // 刷新
    handleRefresh() {
      this.filters = {}; //清空查询条件
      this.findPage();
    },
    //关闭新增和修改志愿者的dialog清除验证
    closeDialogReset() {
      document.getElementById("uppic").value = ""; //每次关闭dialog框都清空上传文件file的值，以防再次打开选择相同的不能触发change时间
      this.filePic = ""; //清空上传的图片文件
      this.avatar = require("@/assets/common/jia.png"); //清空上传的图片显示
      this.$refs.dataForm.resetFields(); //移除校验结果并重置字段值
    },
    changeMobileNo(val) {
      console.log(val);
      this.dataForm.loginName = this.dataForm.mobileNo;
      console.log(this.dataForm.loginName);
    },
    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.findPage();
      }
    },
    // 获取分页数据
    findPage(data) {
        this.pageRequest.pageNum = data
        this.$refs["ktTable"].setPageNum(data);
      //判断查询条件是否存在
      this.filters.userName != undefined
        ? (this.pageRequest.userName = this.filters.userName)
        : (this.pageRequest.userName = "");
      this.filters.mobileNo != undefined
        ? (this.pageRequest.mobileNo = this.filters.mobileNo)
        : (this.pageRequest.mobileNo = "");
      this.filters.sex != undefined
        ? (this.pageRequest.sex = this.filters.sex)
        : (this.pageRequest.sex = "");
      console.log(this.pageRequest);
      this.$postJson("uac/volunteer/queryListWithPage", this.pageRequest)
        .then((res) => {
          console.log(res.result);
          res.result.list.forEach((item) => {
            item.sex == 0 ? (item.sex = "女") : (item.sex = "男");
          });
          this.pageResult = res.result; //将值赋给this.pageResult这个对象
          setTimeout(() => {
            this.loading = false;
          }, 500);
        })
        .then(data != null ? data.callback : "");
    },
    // 分页刷新数据
    refreshPageRequest(data) {
      console.log(data);
      this.pageRequest.pageNum = data;
      this.findPage(data);
    },
    // 删除
    handleDelete(data) {
      console.log(data.params[0].id, data.callback);
      let volunteerId = data.params[0].id;
      console.log(volunteerId);
      this.$postForm("uac/volunteer/deleteById/" + volunteerId).then((res) => {
        console.log(res);
        var info = res;
        data.callback(info);
      });
    },
    //选择服务时间
    changeServiceTime(val) {
      console.log(val);
      this.dataForm.serviceTime = util.formatDate.format(
        new Date(val),
        "yyyy-MM-dd hh:mm:ss"
      );
      console.log(this.dataForm.serviceTime);
    },
    // 显示新增界面
    handleAdd() {
      this.dialogVisible = true;
      this.operation = true;
      this.avatar = require("@/assets/common/jia.png");
      this.submitDisabled = false;
    },
    // 显示编辑界面
    handleEdit(params) {
      this.dialogVisible = true;
      this.operation = false;
      this.$nextTick(() => {
        this.dataForm = Object.assign({}, params.row);
        //头像回显 by xiang
        this.$postForm(
          "opc/file/queryAttachmentById/" + this.dataForm.headerPic
        ).then((res) => {
          if (res.code == 200) {
            this.avatar =
              "http://51cs8.com/" + res.result.path + res.result.name;
          }
        });
      });
      console.log(this.dataForm.headerPic);
      this.getImgInfo(this.dataForm.headerPic);
    },
    //校验只能上传jpg和png格式的图片
    beforeUpload(file) {
      //图片上传之前校验
      console.log(file, "-----------------------进来了");
      if (file != undefined) {
        let isPNG = false;
        file.type == "image/gif" ? (isPNG = false) : (isPNG = true);
        const isLt2048k = file.size / 1024 < 2048;
        if (!isPNG) {
          this.$message.error("上传图片格式不能是 gif 格式");
          return false;
        }
        if (!isLt2048k) {
          this.$message.error("上传图片大小不能超过 2Mb");
          return false;
        }
        console.log(isPNG, isLt2048k);
        return isPNG && isLt2048k;
      }
    },
    //上传图片
    changeImage(e) {
      console.log(e);
      this.filePic = e.target.files[0];
      this.submitDisabled = false;
      if (this.filePic) {
        //判断图片文件是否存在
        this.dataForm.headerPic = "0"; //当选择了图片，暂时给input框一个，防止点确定的时候，图片还没上上传成功，会提示不能为空的红色错误提示框
        this.clearValidate("headerPic"); // 清除gitPic的校验
      }
      var file = e.target.files[0];
      console.log(file);
      //console.log(this.beforeUpload(file))
      if (this.beforeUpload(file)) {
        var reader = new FileReader();
        var that = this;
        if (file != undefined) {
          reader.readAsDataURL(file);
          reader.onload = function () {
            console.log(this.result);
            that.avatar = this.result;
          };
          let params = new FormData();
          params.append("file", file);
          params.append("fileType", this.picture);
          params.append("bucketName", this.bucketName);
          console.log(params);
          this.$postFormData("opc/file/uploadFile", params).then((res) => {
            console.log(res);
            this.dataForm.headerPic = res.result;
            document.getElementById("uppic").value = ""; //每次关闭dialog框都清空上传文件file的值，以防再次打开选择相同的不能触发change时间
            this.submitDisabled = false;
          });
        }
      } else {
        document.getElementById("uppic").value = ""; //每次关闭dialog框都清空上传文件file的值，以防再次打开选择相同的不能触发change时间
      }
    },
    //图片的回显
    getImgInfo(headerPicId) {
      let id = headerPicId;
      console.log(id);
      if (id) {
        this.$postForm("opc/file/queryAttachmentById/" + id).then((res) => {
          console.log(res);
          var path = res.result.path;
          var name = res.result.name;
          this.avatar = "http://51cs8.com/" + path + name;
        });
      }
    },
    // 新增和编辑提交数据
    submitForm() {
      this.$refs.dataForm.validate((valid) => {
        if (valid) {
          this.editLoading = true;
          if(this.dataForm.headerPic  ==  '0'){
            this.dataForm.headerPic = '1001'
          }
          if(this.dataForm.nation == null || this.dataForm.nation == ''){
            this.dataForm.nation = '汉族';
          }
          if(this.dataForm.education == null || this.dataForm.education == ''){
            this.dataForm.education = '本科';
          }
          if(this.dataForm.jobType == null || this.dataForm.jobType == ''){
            this.dataForm.jobType = '企业职工';
          }
          let params = Object.assign({}, this.dataForm);
          console.log(this.operation, params);
          //this.operation==true为新增的url  this.operation==false为修改的url
          let url = "";
          this.operation == true
            ? (url = "uac/volunteer/add")
            : (url = "uac/volunteer/edit");
          console.log(url);
          this.$postJson(url, params).then((res) => {
            console.log(res);
            this.editLoading = false;
            if (res.code == 200) {
              this.$message({ message: "操作成功", type: "success" });
              this.dialogVisible = false;
              this.$refs["dataForm"].resetFields();
            } else {
              this.$message({
                message: "操作失败, " + res.message,
                type: "error",
              });
            }
            this.findPage();
          });
        }
      });
    },
    //查看详情
    handleLook(data) {
      console.log(data);
      let userId = data.row.userId;
      let headerPic = data.row.headerPic;
      console.log(userId);
      this.$router.push({
        path: "/volunteerdetail",
        query: { userId: userId, headerPic: headerPic },
      }); //编程式导航跳转  query传参
    },
    //关闭重置密码的dialog框
    closeDialogResetCode() {
      this.$refs.codeDataForm.resetFields(); //移除校验结果并重置字段值
    },
    //重置密码弹出模态框
    handleResetCode(data) {
      console.log(data);
      this.id = data.row.id;
      this.dialogVisibleCode = true;
      console.log(this.id);
    },
    //重置密码提交数据
    submitFormCode() {
      this.$refs.codeDataForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.codeLoading = true;
            let params = Object.assign({}, this.codeDataForm);
            params.id = this.id;
            console.log(params);
            this.$postJson("uac/volunteer/modifyPwd", params).then((res) => {
              console.log(res);
              this.codeLoading = false;
              if (res.code == 200) {
                this.$message({ message: "操作成功", type: "success" });
                this.dialogVisibleCode = false;
                this.$refs["codeDataForm"].resetFields();
              } else {
                this.$message({
                  message: "操作失败, " + res.message,
                  type: "error",
                });
              }
              this.findPage();
            });
          });
        }
      });
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue, index) {
      return format(row[column.property]);
    },
    // 处理表格列过滤显示
    displayFilterColumnsDialog: function () {
      this.$refs.tableColumnFilterDialog.setDialogVisible(true);
    },
    // 处理表格列过滤显示
    handleFilterColumns: function (data) {
      this.filterColumns = data.filterColumns;
      this.$refs.tableColumnFilterDialog.setDialogVisible(false);
    },
    // 处理表格列过滤显示
    initColumns: function () {
      this.columns = [
        { prop: "userName", label: "姓名", minWidth: 100 },
        { prop: "sex", label: "性别", minWidth: 80 },
        { prop: "age", label: "年龄", minWidth: 80 },
        { prop: "nation", label: "民族", minWidth: 80 },
        { prop: "birthday", label: "生日", minWidth: 100 },
        { prop: "idCard", label: "身份证号", minWidth: 150 },
        { prop: "education", label: "文化程度", minWidth: 110 },
        { prop: "mobileNo", label: "联系电话", minWidth: 120 },
        { prop: "loginName", label: "登录账号", minWidth: 120 },
      ];
      this.filterColumns = JSON.parse(JSON.stringify(this.columns));
    },
    initialSexs() {
      var sexs = ["女", "男"];
      for (var i = 0; i < sexs.length; i++) {
        var item = {};
        item.value = i;
        item.label = sexs[i];
        this.sexOptions.push(item);
      }
    },
    // 初始化民族
    initialNations() {
      var nations = [
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "傈僳族",
        "佤族",
        "畲族",
        "高山族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "景颇族",
        "柯尔克孜族",
        "土族",
        "达斡尔族",
        "仫佬族",
        "羌族",
        "布朗族",
        "撒拉族",
        "毛南族",
        "仡佬族",
        "锡伯族",
        "阿昌族",
        "普米族",
        "塔吉克族",
        "怒族",
        "乌孜别克族",
        "俄罗斯族",
        "鄂温克族",
        "德昂族",
        "保安族",
        "裕固族",
        "京族",
        "塔塔尔族",
        "独龙族",
        "鄂伦春族",
        "赫哲族",
        "门巴族",
        "珞巴族",
        "基诺族",
      ];
      for (var i = 0; i < nations.length; i++) {
        var item = {};
        //item.value = i
        item.value = nations[i];
        item.label = nations[i];
        this.nationOptions.push(item);
      }
    },
    //初始化文化程度
    initialEducations() {
      var educations = [
        "文盲",
        "小学",
        "初中",
        "高中",
        "大专",
        "本科",
        "硕士",
        "博士",
      ];
      for (var i = 0; i < educations.length; i++) {
        var item = {};
        // item.value = i
        item.value = educations[i];
        item.label = educations[i];
        this.educationoptions.push(item);
      }
    },
    //初始化职业类型
    initialProfessionOptions() {
      var professions = [
        "企业职工",
        "教师",
        "医护工作者",
        "自由职业者",
        "演员",
        "其他",
      ];
      for (var i = 0; i < professions.length; i++) {
        var item = {};
        //item.value = i
        item.value = professions[i];
        item.label = professions[i];
        this.professionOptions.push(item);
      }
    },
  },
  created() {
    this.initialSexs();
    this.initialNations();
    this.initialEducations();
    this.initialProfessionOptions();
  },
  mounted() {
    this.initColumns();
    this.findPage();
  },
};
</script>

<style lang="scss" scoped>
.rz-picter {
  width: 100%;
  height: 150px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.rz-picter:hover {
  border-color: #409eff;
}
.img-avatar {
  width: 140px;
  height: 140px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
}
.uppic {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  opacity: 0;
}
// ::deep深度作用选择符
::deep .el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}
//新增 编辑 dialog
@media screen and (max-width: 1599px) {
  ::deep .volunteerdialog .el-dialog {
    width: 80% !important;
  }
}
::deep .el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  width: 100.5%;
  height: 100%;
}
::deep .el-form--inline {
  position: relative;
  z-index: 99;
}
.filtersposition {
  position: absolute;
  top: 10px;
  left: 0;
  right: 0;
  bottom: 10px;
  width: 100%;
  height: 56px;
  background: #f2f2f2;
  z-index: 1;
}
</style>